import PropTypes from "prop-types";
import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import Loading from "components/center-loading";
import { ordersFiltersDefault } from "./components/orders-filter/utils";
import StorePersist from "utils/store-persist";
import { fetchSuggestionsJustifications } from "services/suggestion/suggestion.service";
import { getCancellationJustifications } from "services/orders.service";

const OrdersContext = createContext();

const OrdersProvider = ({ children }) => {
  const [pagination, setPagination] = useState({
    CurrentPage: 0,
    TotalItems: 0,
    TotalPages: 0,
    size: 50,
  });
  const [items, setItems] = useState([]);
  const [checkbox, setCheckbox] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    ...(StorePersist.getValuesJSON("filtersOrdersMulti") ?? ordersFiltersDefault),
    UseFilterDefault: JSON.parse(localStorage.getItem("filterMyItemsOnly")),
  });

  const [justifications, setJustifications] = useState([]);
  const [justificationsLoading, setJustificationsLoading] = useState(false);
  const [cancellationJustifications, setCancellationJustifications] = useState([]);

  const loadJustifications = useCallback(async () => {
    try {
      setJustificationsLoading(true);
      const data = await fetchSuggestionsJustifications();
      setJustifications(
        (Array.isArray(data) ? data : []).map((item) => ({
          Id: item.Key,
          Description: item.Value,
        }))
      );
    } catch (err) {
      console.error("Failed to fetch justifications:", err);
      setJustifications([]);
    } finally {
      setJustificationsLoading(false);
    }
  }, []);

  const loadCancelationJustifications = useCallback(async () => {
    try {;
      const data = await getCancellationJustifications();
      setCancellationJustifications(data);
    } catch (err) {
      console.error("Failed to fetch justifications:", err);
    }
  }, []);

  useEffect(() => {
    loadJustifications();
    loadCancelationJustifications();
  }, [loadJustifications]);

  const value = useMemo(
    () => ({
      items,
      setItems,
      pagination,
      setPagination,
      filter,
      setFilter,
      checkbox,
      setCheckbox,
      loading,
      setLoading,
      justifications,
      justificationsLoading,
      reloadJustifications: loadJustifications,
      cancellationJustifications
    }),
    [
      items,
      pagination,
      filter,
      checkbox,
      loading,
      justifications,
      justificationsLoading,
      loadJustifications,
      cancellationJustifications
    ]
  );

  return (
    <OrdersContext.Provider value={value}>
      {children}
      <Loading isLoading={loading} />
    </OrdersContext.Provider>
  );
};

OrdersProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

const useOrdersContext = () => useContext(OrdersContext);

export { OrdersProvider, OrdersContext, useOrdersContext };
